function init(): void {
    const getStoredTheme = (): null | string => localStorage.getItem('theme');
    const setStoredTheme = (theme: string): void => {
        localStorage.setItem('theme', theme);
    };

    const getPreferredTheme = (): string => {
        const storedTheme = getStoredTheme();

        if (storedTheme != null) {
            return storedTheme;
        }

        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    };

    const setTheme = (theme: string): void => {
        if (theme === 'auto') {
            document.documentElement.setAttribute(
                'data-bs-theme',
                window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
            );
        } else {
            document.documentElement.setAttribute('data-bs-theme', theme);
        }
    };

    setTheme(getPreferredTheme());

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (): any => {
        const storedTheme = getStoredTheme();
        if (storedTheme !== 'light' && storedTheme !== 'dark') {
            setTheme(getPreferredTheme());
        }
    });

    window.addEventListener('DOMContentLoaded', (): any => {
        document.querySelectorAll('[data-bs-theme-value]').forEach((toggle): any => {
            toggle.addEventListener('click', (): any => {
                const theme = toggle.getAttribute('data-bs-theme-value');

                if (theme == null) {
                    return;
                }

                setStoredTheme(theme);
                setTheme(theme);
            });
        });
    });
}

// ----------------------------------------------------------------------------

export { init };
